import { atom } from 'recoil';

/**
 * 사업구분
 */
export const btypeState = atom<string>({
  key: 'btypeState',
  default: 'ESL',
});
